import { FC } from "react";
import { useTranslation } from "react-i18next";
import styles from "@/components/draftBadge/draftBadge.module.css";

interface Props {
  className?: string;
}

const DraftBadge: FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <span className={`${styles.draftBadge} ${className ?? ""}`.trim()}>
      {t("draft_mode_badge")}
    </span>
  );
};

export default DraftBadge;
